import { ServiceRequestInstance, ServiceRequestPaymentStatusMap, ServiceRequestStatusMap } from "../../../../../model/service-request/service-request-instance";
import { formatTimestamp } from "../../../../../utils";
import styles from "./ServiceRequesInstancesPage.module.scss";

interface Props {
	record: ServiceRequestInstance;
	statusClassMap: Record<string, string>;
	onClick: () => void;
}

const ServiceRequestInstanceCard = ({ record, statusClassMap, onClick }: Props) => {
	const paymentStatus = ServiceRequestPaymentStatusMap[record.paymentStatus];
	const status = ServiceRequestStatusMap[record.status];

	return (
		<div className={styles.card} onClick={onClick}>
			<div className={styles.cardHeader}>
				<span className={styles.cardName}>{record.customerFirstName} {record.customerLastName}</span>
				<span className={styles.cardDate}>{formatTimestamp(record.createdAt ?? "")}</span>
			</div>
			<div className={styles.cardBody}>
				<div className={styles.cardRow}>
					<span className={styles.cardLabel}>Payment Status</span>
					<span className={styles.cardValue}>
						<div className={`${styles.circle} ${statusClassMap[paymentStatus]}`} />
						{paymentStatus}
					</span>
				</div>
				<div className={styles.cardRow}>
					<span className={styles.cardLabel}>Status</span>
					<span className={styles.cardValue}>
						<div className={`${styles.circle} ${statusClassMap[status]}`} />
						{status}
					</span>
				</div>
			</div>
		</div>
	);
};

export default ServiceRequestInstanceCard;
